import {area} from "@/class/interactive-image/area";
import {hotspot} from "@/class/interactive-image/hotspot";
import {marker} from "@/class/interactive-image/marker";
import {overlay} from "@/class/interactive-image/overlay";
import {text} from "@/class/interactive-image/text";
import {xrayspot} from "@/class/interactive-image/xrayspot";
import {boundingzoom} from "@/class/interactive-image/boundingzoom";
import store from "@/store/store";

import axios from "@/axios";
import events from "@/events/events";
import {viewModel} from "@/class/view-model";
import {Media, PK} from "@/class/data-type";

/*
 * L'objet Chapter gère les données du chapitre et stock les labels
 * Lors d'un cancel, seul les donnée du chapitre sont restoré, les labels ne sont pas impacté.
 */

export default class extends viewModel{
    
    objectType = "interactive-chapter"
    
    boundingzooms = [];
    
    isEditing = false;
    isFake = false;
    
    data = [
        {name: "interactive_image", type: Number, default: 0},
        {name: "title", type: String, default: "New chapter"},
        {name: "teaser", type: String, default: ""},
        {name: "base_image", type: Media, default: new Media({type:"picture"})},
        {name: "order", type: Number, default: 0},
        {name: "order", type: Number, default: 0},
    ]
    
    constructor() {
        super();
        this.init();
        
        store.getters.labels("interactive_image").forEach((label) => {
            this[label.type+"s"] = []
        })
    }
    
    setDataReq(data){
        super.setDataReq(data);
        
        store.getters.labels("interactive_image").forEach((label) => {
            let type = label.type+"s";
            
            if(data[type]){
                this[type] = [];
                data[type].forEach((_label) => {
                    this[type].push(new label.class().setDataReq(_label,this.getId(),this.getStoryId()))
                });
            }
        })
        return this;
    }
    
    getData() {
    
        let data = {}
        this.data.forEach((d) => {
            data[d.name] = this[d.name];
        })
    
        store.getters.labels("interactive_image").forEach((label) => {
            data[label.type+"s"] = this[label.type+"s"];
        })
        
        data["boundingzooms"] = this.boundingzooms
        
        return data;
    }
    
    getLabelsByType(type) {
        return this[type+"s"].filter(l => l.deleted === false);
    }
    
    getBaseImage() {
        // if (this.order === 0 && !this.base_image.media) {
        //     return store.getters.getDefault("BaseImage");
        // }
        return this.base_image.media;
    }
    
    getAllLabel(all = false) {
        
        let labels = []
    
        store.getters.labels("interactive_image").forEach((label) => {
            labels = [...labels,...this[label.type+"s"].filter(l => l.isDeleted() === false || all)];
        })
        
        this.orderLabels(labels)
        
        return labels;
    }
    
    orderLabels(labels){
        
        labels.sort((l1,l2) => {
            if( l1.order > l2.order) return -1;
            if( l1.order < l2.order) return 1;
            if( l1.order === l2.order) return 0;
        })
    
        labels.map((label,key) => {
            label.order = labels.length - (key + 1);
        })
        
    }
    
    addLabel(type, label) {
        
        if(type === "boundingzoom"){
            this.boundingzooms = []
            this.boundingzooms.push(new boundingzoom().setDataReq(label, this.getId(), this.getStoryId(), ))
            return this.boundingzooms[0];
        }
        
        let object = store.getters.label("interactive_image",type)
        let newLabel = new object.class().setDataReq(label, this.getId(), this.getStoryId())
        this[type+"s"].push(newLabel)

        return newLabel
    }
    
    removeLabel(type,label){
        this[type+"s"] = this[type+"s"].filter(l => l.getId() !== label.getId())
    }
    
    // mise en cache de l'image principal
    async loadImage() {
        return new Promise((resolve, reject) => {
            
            if(!this.base_image.media) return resolve();
            
            let currentImage = new Image;
            currentImage.src = this.base_image.media;
            currentImage.onload = () => {
                resolve();
            };
            
        });
    }
    
    async save(saveLabels) {
        
        if(!await super.save()){
            return false;
        }
        
        if(saveLabels){
            if(!await this.saveLabels()){
                return false;
            }
        }
        
        return true;
        
    }
    
    async saveLabels(){
        let promises = [];
        
        this.getAllLabel(true).map((label) => {
            promises.push(label.save());
        })
        
        return Promise.all(promises);
    }
    
    edit(){
        this.isEditing = true;
        return this;
    }
    unedit(){
        this.isEditing = false;
        return this;
    }
    fake(){
        this.isFake = true;
        return this;
    }
    valide(){
        return !this.isFake;
    }
}